import React ,{useState,useEffect,useCallback } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../Config/Base'
import { ToastContainer,toast } from 'react-toastify'
import pic from '../Assets/Images/payment-method.png'
import _ from 'lodash'


const pageSize = 5;


const ParoPaymentMain = () => {


  const [allusers,setAllusers]= useState([])

  
  const [paginatedPosts, setpaginatedPosts] = useState();
  // const [currentPage, setcurrentPage] = useState(1);
    
     useEffect(()=>{
         
     
       GetAllPaymentDetails();
       getRoleData();
       getParouserRole();
// setTimeout(() => {
                
     
//     }, 2000);
      },[])
   

/**** Section view task****/

function getRoleData(){
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
 let UserRole =  localStorage.getItem("Role");

 const body ={
  
  role:UserRole

 }
 console.log(body);


  axios({          
     method: "POST", 
     url: `${BASE_URL}/Paropakari/GetParoLoginUserRole`,      
    //  url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
     data:body,
     headers: {             
       'Content-Type': 'application/json' , 
       'Authorization':bearer     
     }
   
   })
   .then((response) =>{
    console.log(response.data);
    localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
    
     }) 
   
    }



    function getParouserRole(){
  
      let Corprole =  localStorage.getItem("loginUserRoleaction");
      let roledata =  JSON.parse(Corprole);
      let role = roledata.map((e)=>e.userroleaction);
      console.log(role);
      localStorage.setItem("ROLE",role)
    
      let roles = role.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      localStorage.setItem("add",roleResult)

      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      localStorage.setItem("View",roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      localStorage.setItem("Edit",roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
      localStorage.setItem("Delete",roleResultC)

      let empty = roles.includes('')
      console.log(empty)

     let roleid = localStorage.getItem('RoleId')
     let id = roleid.includes('01')
     console.log(id)

      /*---- Show delete----*/ 

      if(id==true&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
      {
       setCorpdisplay(true);
       setCorpEditdisplay(true);
       setCorpDeletedisplay(true);
      
      }
      if(id==false&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
      {
       setCorpdisplay(false);
       setCorpEditdisplay(false);
       setCorpDeletedisplay(false);
        document.getElementById('Paro-TopTbl').style.display ="none";
        document.getElementById('Paropagi').style.display ="none";
        document.getElementById('makepay').style.display ="none";
        document.getElementById('Paroaction-err').innerHTML = 'Not Assign'
        document.getElementById('Paroaction-err').style.color = "red"
        document.getElementById('Paroaction-err').style.fontWeight = "bold"
        document.getElementById('Paroaction-err').style.alignItems = "center"
        document.getElementById('Paroaction-err').style. justifyContent = "center"
        document.getElementById('Paroaction-err').style. display= "flex"

        
      }



       /*---- Show delete----*/ 
  
if(roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==true){
setCorpdisplay(true);
setCorpEditdisplay(false);
setCorpDeletedisplay(true);
document.getElementById('makepay slide_left').style.display ="none";

}


       /*---- Show add view----*/ 

  if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==false){
    setCorpdisplay(false);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(false);
    document.getElementById('makepay slide_left').style.display ="block";
  
  }

/*---- Show add ----*/ 
  
  if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==false){
    setCorpdisplay(false);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(false);
    document.getElementById('makepay slide_left').style.display ="block";
  
  }

  /*---- Show Edit----*/ 
  
  if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
    setCorpdisplay(false);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(false);
    document.getElementById('makepay slide_left').style.display ="none";
  
  }

  

    /*---- Show view----*/ 
  
    if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
      setCorpdisplay(false);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(false);
      document.getElementById('makepay slide_left').style.display ="none";
    
    }






      
     /*---- Show add edit delete view----*/

     if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==false){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(false);
      document.getElementById('makepay slide_left').style.display ="block";

    }
     
      if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==false){
        
        document.getElementById('Pmakepay slide_left').style.display ="block";
      }

      if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
       
        setCorpdisplay(false);
        
       document.getElementById('makepay slide_left').style.display ="none";
     }

     if(roleResult==false&&roleResultA==false&&roleResultB==true&&roleResultC==false){

      document.getElementById('makepay slide_left').style.display ="none";
      setCorpDeletedisplay(false);
      setCorpdisplay(true);
     }

     if(roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==true){
      document.getElementById('makepay slide_left').style.display ="none";
      setCorpEditdisplay(false);
     
     }


     /*---- Show add edit delete view----*/

    if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==true){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(true);
      document.getElementById('makepay slide_left').style.display ="block";

    }



   

     /*---- Show delete and edit view----*/

     if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==true){
      setCorpdisplay(true);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(true);
      document.getElementById('makepay slide_left').style.display ="block";

    }

    

    


    /*---- Show add edit ----*/

    if(roleResult==true&&roleResultA==false&&roleResultB==true&&roleResultC==false){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(false);
      document.getElementById('makepay').style.display ="block";

    }

 /*---- Show add view----*/ 

  if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==false){
  setCorpdisplay(false);
  setCorpEditdisplay(false);
  setCorpDeletedisplay(false);
  document.getElementById('makepay').style.display ="block";

}


/*---- Show edit delete ----*/

if(roleResult==false&&roleResultA==false&&roleResultB==true&&roleResultC==true){
  setCorpdisplay(true);
  setCorpEditdisplay(true);
  setCorpDeletedisplay(true);
  document.getElementById('makepay').style.display ="none";

}


/*---- Show edit view----*/

if(roleResult==false&&roleResultA==true&&roleResultB==true&&roleResultC==false){
  setCorpdisplay(true);
  setCorpEditdisplay(true);
  setCorpDeletedisplay(false);
  document.getElementById('makepay').style.display ="none";

}





/*---- Show delete view----*/

if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==true){
  setCorpdisplay(true);
  setCorpEditdisplay(false);
  setCorpDeletedisplay(true);
  document.getElementById('makepay').style.display ="none";

}


 /*---- Show add delete----*/

 if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==true){
  setCorpdisplay(true);
  setCorpEditdisplay(false);
  setCorpDeletedisplay(true);
  document.getElementById('makepay').style.display ="block";

}

/*---- Show add edit view----*/

if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==false){
  setCorpdisplay(true);
  setCorpEditdisplay(true);
  setCorpDeletedisplay(false);
  document.getElementById('makepay').style.display ="block";

}

/*---- Show add delete  view----*/

if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==true){
  setCorpdisplay(true);
  setCorpEditdisplay(false);
  setCorpDeletedisplay(true);
  document.getElementById('makepay').style.display ="block";

}

  

/*---- Show edit delete view----*/

if(roleResult==false&&roleResultA==true&&roleResultB==true&&roleResultC==true){
  setCorpdisplay(true);
  setCorpEditdisplay(true);
  setCorpDeletedisplay(true);
  document.getElementById('makepay').style.display ="none";

}

    /*---- Show add edit delete view----*/

    if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==true){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(true);
      document.getElementById('makepay').style.display ="block";

    }

  
  }


  const[Corpdisplay, setCorpdisplay] =useState(true);
    const[CorpEditdisplay, setCorpEditdisplay] =useState(true);
    const[CorpDeletedisplay, setCorpDeletedisplay] =useState(true);
        

     

      function fetchPaymentData()
      {
    
        var Name = document.getElementById("payname").value;
        var Date = document.getElementById("paydate").value;
        var Amount = document.getElementById("amounttopay").value;
        // var PaymentStatus = document.getElementById("paymentstatus").value;
        var MobileNumber = document.getElementById("paymobilenumber").value;
        var mobPattern = /^(?:(?:\\+|0{0,2})91(\s*[\\-]\s*)?|[0]?)?[6789]\d{9}$/;
        var Email = document.getElementById("payemail").value;
        var mailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        var Account = document.getElementById("payaccount").value;
        var Ifsc = document.getElementById("payifsc").value;
        var IFSCpattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;



        var Upi = document.getElementById("payupi").value;


        if(Name == "")
        {
          document.getElementById("PayError").innerHTML = "Name Required"
        }
        else if(Name)
        {
          document.getElementById("PayError").innerHTML = ""
        }

        if(Date == "")
        {
          document.getElementById("PayError1").innerHTML = "Date Reuired"
        }
        else if(Date)
        {
          document.getElementById("PayError1").innerHTML = ""
        }
        if(Amount=="")
        {
          document.getElementById("PayError2").innerHTML = "Amount Required"
        }
        else if (Amount)
        {
          document.getElementById("PayError2").innerHTML = " "
        }


        // if(PaymentStatus=="")
        // {
        //   document.getElementById("PayError3").innerHTML = "Payment Status Required *"
        // }
        // else if (PaymentStatus)
        // {
        //   document.getElementById("PayError3").innerHTML = " "
        // }
        

        if(MobileNumber=="")
        {
          document.getElementById("PayError4").innerHTML = "Mobile Numer Required";
          document.getElementById("PayError4A").innerHTML = "";
        }
        else if (mobPattern.test(document.getElementById("paymobilenumber").value)===false)
        {
          document.getElementById("PayError4A").innerHTML = "Enter Valid Mobile Number";
          document.getElementById("PayError4").innerHTML = "";
        }
        else{
          document.getElementById("PayError4").innerHTML ="";
          document.getElementById("PayError4A").innerHTML = "";
        }

        if(Email=="")
        {
          document.getElementById("PayError5").innerHTML = "Email Required ";
          document.getElementById("PayError5A").innerHTML = "";
        }
        else if (mailPattern.test(document.getElementById("payemail").value)===false)
        {
          document.getElementById("PayError5A").innerHTML = "Not Valid Email";
          document.getElementById("PayError5").innerHTML = "";
        }
        else{
          document.getElementById("PayError5").innerHTML = " ";
          document.getElementById("PayError5A").innerHTML = "";
        }


        if(Account=="")
        {
          document.getElementById("PayError6").innerHTML = "Account Number Required"
        }
        else if (Account)
        {
          document.getElementById("PayError6").innerHTML = ""
        }


        if(Ifsc=="")
        {
          document.getElementById("PayError7").innerHTML = "Ifsc Number Required";
          document.getElementById("PayError7A").innerHTML = ""
        }
        else if (IFSCpattern.test(document.getElementById("payifsc").value)===false)
        {
          document.getElementById("PayError7A").innerHTML = "Enter valid Ifsc Number";
          document.getElementById("PayError7").innerHTML = ""
        }

        else{
          document.getElementById("PayError7A").innerHTML = "";
          document.getElementById("PayError7").innerHTML = ""
        }

        if(Upi=="")
        {
          document.getElementById("PayError8").innerHTML = "Upi Id Required *"
        }
        else if (Upi)
        {
          document.getElementById("PayError8").innerHTML = ""
        }


        if(Name&&Date&&Amount&&(mobPattern.test(document.getElementById("paymobilenumber").value)===true)&&(mailPattern.test(document.getElementById("payemail").value)===true)&& Account&& (IFSCpattern.test(document.getElementById("payifsc").value)===true)&&Upi)
        {
    
        const body = {
    
          Name:Name,
          Date:Date,
          Amount_to_pay:Amount,
          Payment_status:"Pending",
          Mobile_number:MobileNumber,
          Email:Email,
          Bank_account:Account,
          IFSC:Ifsc,
          UPI:Upi,
        }
    
        const token = JSON.parse(localStorage.getItem('usertoken'));
    
      axios({
        method: 'post',
        url: `https://localhost:44312/Api/Paropakari/AddPayment`,
        data: body
    })
    .then((response) =>{
          console.log(response.data);
    
          if(response.data.status === "Success")
          {
            alert("Maked Successfully");
          }
          GetAllPaymentDetails();
          
          SaCloseform();

        })
        .catch(function (error) {
              console.log(error);
           });
  }
  
}


function paymentValidation()
{
  var Name = document.getElementById("payname").value;
  var Date = document.getElementById("paydate").value;
  var Amount = document.getElementById("amounttopay").value;
  // var PaymentStatus = document.getElementById("paymentstatus").value;
  var MobileNumber = document.getElementById("paymobilenumber").value;
  var mobPattern = /^(?:(?:\\+|0{0,2})91(\s*[\\-]\s*)?|[0]?)?[6789]\d{9}$/;
  var Email = document.getElementById("payemail").value;
  var mailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
  var Account = document.getElementById("payaccount").value;
  var Ifsc = document.getElementById("payifsc").value;
  var IFSCpattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;



  var Upi = document.getElementById("payupi").value;


  if(Name == "")
  {
    document.getElementById("PayError").innerHTML = "Name Required"
  }
  else if(Name)
  {
    document.getElementById("PayError").innerHTML = ""
  }

  if(Date == "")
  {
    document.getElementById("PayError1").innerHTML = "Date Reuired"
  }
  else if(Date)
  {
    document.getElementById("PayError1").innerHTML = ""
  }
  if(Amount=="")
  {
    document.getElementById("PayError2").innerHTML = "Amount Required"
  }
  else if (Amount)
  {
    document.getElementById("PayError2").innerHTML = " "
  }


  // if(PaymentStatus=="")
  // {
  //   document.getElementById("PayError3").innerHTML = "Payment Status Required *"
  // }
  // else if (PaymentStatus)
  // {
  //   document.getElementById("PayError3").innerHTML = " "
  // }
  

  if(MobileNumber=="")
  {
    document.getElementById("PayError4").innerHTML = "Mobile Numer Required";
    document.getElementById("PayError4A").innerHTML = "";
  }
  else if (mobPattern.test(document.getElementById("paymobilenumber").value)===false)
  {
    document.getElementById("PayError4A").innerHTML = "Enter Valid Mobile Number";
    document.getElementById("PayError4").innerHTML = "";
  }
  else{
    document.getElementById("PayError4").innerHTML ="";
    document.getElementById("PayError4A").innerHTML = "";
  }

  if(Email=="")
  {
    document.getElementById("PayError5").innerHTML = "Email Required ";
    document.getElementById("PayError5A").innerHTML = "";
  }
  else if (mailPattern.test(document.getElementById("payemail").value)===false)
  {
    document.getElementById("PayError5A").innerHTML = "Not Valid Email";
    document.getElementById("PayError5").innerHTML = "";
  }
  else{
    document.getElementById("PayError5").innerHTML = " ";
    document.getElementById("PayError5A").innerHTML = "";
  }


  if(Account=="")
  {
    document.getElementById("PayError6").innerHTML = "Account Number Required"
  }
  else if (Account)
  {
    document.getElementById("PayError6").innerHTML = ""
  }


  if(Ifsc=="")
  {
    document.getElementById("PayError7").innerHTML = "Ifsc Number Required";
    document.getElementById("PayError7A").innerHTML = ""
  }
  else if (IFSCpattern.test(document.getElementById("payifsc").value)===false)
  {
    document.getElementById("PayError7A").innerHTML = "Enter valid Ifsc Number";
    document.getElementById("PayError7").innerHTML = ""
  }

  else{
    document.getElementById("PayError7A").innerHTML = "";
    document.getElementById("PayError7").innerHTML = ""
  }

  if(Upi=="")
  {
    document.getElementById("PayError8").innerHTML = "Upi Id Required *"
  }
  else if (Upi)
  {
    document.getElementById("PayError8").innerHTML = ""
  }
}



    function DeletePayment(Id)
    {
    var ans=window.confirm('Are you Sure want to delete this Payment');
    
    if(ans == true)
    {
      const body = 
      {
        transactionId:Id
      }
      console.log('check',body)
      axios({
        method:"post",
        url:`${BASE_URL}/Paropakari/PaymentDelete`,
        data:body
      })
      .then((response) => {
        console.log(response.data);
        alert("Deleted Successfully ");
        GetAllPaymentDetails()
      })
      .catch(error => {
        console.log(error);
         alert("failed !")       
         })
    }

  }


    const [EditParoSection ,SetEditParoSection] =useState([]);
   
  
    
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

    function closeEditForm(){
        document.getElementById('DisplayPayEditPop').style.display="none";
        document.getElementById("Parosectionform").reset();

        document.getElementById("UpdateSecErrA").innerHTML=" ";
        document.getElementById("UpdateSecErrB").innerHTML=" ";
        document.getElementById("UpdateSecErrC").innerHTML=" ";
        document.getElementById("UpdateSecErrD").innerHTML=" ";
        document.getElementById("UpdateSecErrE").innerHTML=" ";


       // document.getElementById('Parosectionform').reset();
       }

           /*----Edit Payment----*/

           function EditPaymentDetails(Id){
            const token = JSON.parse(localStorage.getItem('usertoken'));
        
            var inputA = document.getElementById("editpayname").value;
            var inputB = document.getElementById("editpaynumber").value;
            var mobPattern = /^(?:(?:\\+|0{0,2})91(\s*[\\-]\s*)?|[0]?)?[6789]\d{9}$/;
           
            var inputC = document.getElementById("editpayemail").value;
            var mailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
            var inputD = document.getElementById("editpaydate").value;
            var inputE = document.getElementById("editpaysts").value;
        
        
        
            if(!inputA){

              document.getElementById("UpdateSecErrA").innerHTML="Name Required";
             }
      
             else if(inputA){
              document.getElementById("UpdateSecErrA").innerHTML=" ";
      
             }

             
        
             if(inputB=="")
             {
               document.getElementById("UpdateSecErrC").innerHTML = "Mobile Numer Required";
               document.getElementById("UpdateSecErrC1").innerHTML = "";
             }
             else if (mobPattern.test(document.getElementById("editpaynumber").value)===false)
             {
               document.getElementById("UpdateSecErrC1").innerHTML = "Enter Valid Mobile Number";
               document.getElementById("UpdateSecErrC").innerHTML = "";
             }
             else{
               document.getElementById("UpdateSecErrC").innerHTML ="";
               document.getElementById("UpdateSecErrC1").innerHTML = "";
             }
     
             if(inputC=="")
             {
               document.getElementById("UpdateSecErrD").innerHTML = "Email Required ";
               document.getElementById("UpdateSecErrD1").innerHTML = "";
             }
             else if (mailPattern.test(document.getElementById("editpayemail").value)===false)
             {
               document.getElementById("UpdateSecErrD1").innerHTML = "Not Valid Email";
               document.getElementById("UpdateSecErrD").innerHTML = "";
             }
             else{
               document.getElementById("UpdateSecErrD").innerHTML = " ";
               document.getElementById("UpdateSecErrD1").innerHTML = "";
             }
     
           
             if(!inputD){

              document.getElementById("UpdateSecErrB").innerHTML="Date Required";
             }
      
             else if(inputD){
              document.getElementById("UpdateSecErrB").innerHTML=" ";
      
             }
             if(!inputE){

              document.getElementById("UpdateSecErrE").innerHTML="Payment Status Required";
             }
      
             else if(inputE){
              document.getElementById("UpdateSecErrE").innerHTML=" ";
      
             }

             if(inputA&&(mailPattern.test(document.getElementById("editpayemail").value)===true)&&(mailPattern.test(document.getElementById("editpayemail").value)===true)&& inputD&&inputE){

   
             
             const body ={
              
              transactionId:Id,
              Name: inputA ,
              Mobile_Number:inputB,
              Email:inputC,
              Date:inputD,
              Payment_status : inputE 
             }
             // console.log(body);
         
             axios({
             
              method: "POST",
              
              url: `${BASE_URL}/Paropakari/EditPayment`,
              data:body,
              headers: {
                
                'Content-Type': 'application/json' ,    
                "Authorization": "Bearer " +`${token}`  
               
              }
            
            })
           
            .then((response) =>{
              console.log(response.data);
             
                
                     if(response.data.status === "Success"){
                
                     alert("Updated Successfully")
                         GetAllPaymentDetails()
                          closeEditForm()
                      }
                     
               })
        
               .catch(error => {
                console.log(error);
                
              })
            }

          }
             


     /*----Get select to the particular Id in Payment----*/

function SelectPayment(Id){

    const token = JSON.parse(localStorage.getItem('usertoken'));
  
    document.getElementById("DisplayPayEditPop").style.display = "block";
  
     const body =
      {
        
        transactionId:Id
      }
      console.log('body',body);
  
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Paropakari/SelectPayment`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer " +`${token}`,
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
       
            SetEditParoSection(response.data);
       
         })
         .catch(error => {
           console.log(error);
           
         })
  
   }



    // Get Payment Details-------

   const[payment, setPayment] =useState([])


   function  GetAllPaymentDetails(){

     fetch(`https://localhost:44312/Api/Paropakari/GetAllPaymentDetails`, {
      
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
    .then(data => {
      console.log("Data",data)
      setAllusers(data);
setpaginatedPosts(_(data).slice(0).take(pageSize).value());
localStorage.setItem("paro-PaymentData", JSON.stringify(data));

    });
  
   // console.log("check",allVentures)
  }


  // const pageCount = allusers? Math.ceil(allusers.length/pageSize) : 0 ;
  // // if (pageCount === 1)
  // // return null;
  
  // const pages = _.range(1, pageCount+1)
  
  // const pagination =(pageNo)=>{
  // setcurrentPage(pageNo);
  // const startIndex = (pageNo-1) * pageSize;
  // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  // setpaginatedPosts(paginatedPost)
  // }


    function Saopenform()

    {

       document.getElementById("PaymentForm").style.display = "block";

     }


     function SaCloseform()

     {
      document.getElementById("payform").reset();

        document.getElementById("PaymentForm").style.display = "none";

        document.getElementById("PayError").innerHTML = "";
        
        document.getElementById("PayError1").innerHTML = "";
        document.getElementById("PayError2").innerHTML = "";
        // document.getElementById("PayError3").innerHTML = "";
        document.getElementById("PayError4").innerHTML = "";
        document.getElementById("PayError4A").innerHTML = ""
        document.getElementById("PayError5").innerHTML = "";
        document.getElementById("PayError5A").innerHTML = ""
        document.getElementById("PayError6").innerHTML = "";
        document.getElementById("PayError7").innerHTML = "";
        document.getElementById("PayError7A").innerHTML = ""
        document.getElementById("PayError8").innerHTML = "";

 



      }
       
      const LEFT_PAGE = "LEFT";
      const RIGHT_PAGE = "RIGHT";
      const range = (from, to, step = 1) => {
        let i = from;
        const range = [];
      
        while (i <= to) {
          range.push(i);
          i += step;
        }
      
        return range;
      };
      
      const [currentPage, setCurrentPage] = useState(1);
      
      let data = localStorage.getItem("paro-PaymentData")
      let transdata =  JSON.parse(data);
      console.log(transdata,'aaaa')
      let NUM_OF_RECORDS = transdata.length;
      let LIMIT = 5;
      
      const onPageChanged = useCallback(
      
        (event, page) => {
          event.preventDefault();
          setCurrentPage(page);
        },
        [setCurrentPage]
        
      );
      
      
      const currentData = transdata.slice(
        (currentPage - 1) * LIMIT,
        (currentPage - 1) * LIMIT + LIMIT
      );
      
      const Paginations = (props) => {
        const {
          totalRecords,
          pageLimit,
          pageNeighbours,
          onPageChanged,
          currentPage
        } = props;
        const [totalPages, setTotalPages] = useState(0);
        useEffect(() => {
          setTotalPages(Math.ceil(totalRecords / pageLimit));
        }, [setTotalPages]);
      
        const fetchPageNumbers = () => {
          const totalNumbers = pageNeighbours * 1 + 0;
        
          const totalBlocks = totalNumbers + 2;
         
          if (totalPages > totalBlocks) {
            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      
            let pages = range(startPage, endPage);
      
            const hasLeftSpill = startPage > 2;
            const hasRightSpill = totalPages - endPage > 1;
            const spillOffset = totalNumbers - (pages.length + 1);
      
            switch (true) {
              case hasLeftSpill && !hasRightSpill: {
                const extraPages = range(startPage - spillOffset, startPage - 1);
                pages = [LEFT_PAGE, ...extraPages, ...pages];
                break;
              }
              case hasLeftSpill && hasRightSpill:
              default: {
                pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                break;
              }
            }
            return [1, ...pages, totalPages];
          }
          return range(1, totalPages);
        };
      
      
        const pages = fetchPageNumbers() || [];
        return (
          <nav aria-label="Countries Pagination">
            <ul className="pagination" id='Paro-pag'>
              {pages.map((page, index) => {
                if (page === LEFT_PAGE)
                  return (
                    <li key={index} className="Paropage-item">
                      <a
                        href="/"
                        className="page-link"
                        aria-label="Previous"
                        onClick={(e) => onPageChanged(e, pageNeighbours)}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                  );
      
                if (page === RIGHT_PAGE)
                  return (
                    <li key={index} className="Paropage-item">
                      <a
                        className="page-link"
                        href="/"
                        aria-label="Next"
                        onClick={(e) => onPageChanged(e, pageNeighbours )}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  );
      
                return (
                  <li
                    key={index}
                    className={`Paropage-item${currentPage === page ? " active" : ""}`}
                  >
                    <a
                      className="page-link"
                      href="/"
                      onClick={(e) => onPageChanged(e, page)}
                    >
                      {page}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
        );
      };

  return (
    <div className='Paro-addmain'>

<div className="Paro-addgrid-layout">
    <div className="Paro-addmain-top">
        <div className='Paro-addmain-back'>
           <Link to='/ParoSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>
            Payment
           </span>
 

     </div>
 </div>


 <span id="Paroaction-err"></span>

 <div  className='Paro-addmain-add'>
  <button className='Paro-add-user' id="makepay" onClick={Saopenform}> Make Payment</button>
  {/* <button className='updatepay slide_left'><Link to='/ParoUpdatePayment'>Update Payment</Link></button> */}
 
  
</div>



{/*Pay EditPopup */}

<div className='Paropop-fade' id="DisplayPayEditPop" style={{overflow:"auto"}}>
{EditParoSection.map((e)=>{
   return<div className="modal-dialog" role="document" id="ParoEditbotform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT PAYMENT</h4>
        <button type="button" className="close" onClick={closeEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="Parosectionform" onSubmit={() =>EditPaymentDetails(e.transactionId)}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
        <label id="ParoSectionTable"> Name</label> 
          <input type="text" id="editpayname"  defaultValue={e.name} />
          <span id="UpdateSecErrA" className='error'></span>
        </div> 

        <div className="md-form mb-5">
        <label id="ParoSectionTable">Date</label> 
         <input type="date" id='editpaydate' defaultValue={e.date}/>
         <span id="UpdateSecErrB" className='error'></span>
        </div>

        <div className="md-form mb-5">
        <label id="ParoSectionTable" >Mobile Number</label> 
         <input type="text" id='editpaynumber' defaultValue={e.mobile_number} />
         <span id="UpdateSecErrC" className='error'></span>
         <span id="UpdateSecErrC1" className='error'></span>
         
        </div>

        <div className="md-form mb-5" >
        <label id="ParoSectionTable">Email</label> 
         <input type="text" id='editpayemail' defaultValue={e.email}/>
         <span id="UpdateSecErrD" className='error'></span>
         <span id="UpdateSecErrD1" className='error'></span>
        </div>
      </div>

      <div className="md-form mb-5">
      {/* <label id="ParoSectionTable">Payment Status</label>  */}
      <select  name="Payement Status" id="editpaysts" >

<option value="">Payement Status</option>
<option value="Pending">Pending</option>
<option value="Completed">Completed</option>
<option value="In Progress">In Progress</option>
</select>    
<span id="UpdateSecErrE" className='error' style={{marginLeft:"30px"}}></span>
        </div>
      
      <div className="modal-footer d-flex justify-content-center">
        <button className='Paro-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>


<div className='Paro-table'>
<div className='Paro-table-responsive' id='Paro-TopTbl' >

{
            !currentData ? ("No data found"):(
<table >
      <thead>
        <tr>
          <th>Transaction Id</th>
          <th> Name</th>
          <th>Date  </th>
          <th>Amount To Pay</th>
          <th>Mobile Number</th>
          <th>Email </th>
          <th>Bank Account</th>
          <th>Payment Status</th>
          <th>Ifsc</th>
          <th>Upi</th>
          {Corpdisplay?<th>Action</th>:null}



          {/* <th>Logo</th> */}
          

        </tr>
      </thead>
      <tbody>

         {/* mapping to addVenture */}

       
         {currentData.map((e,Index)=>
            { 
              return<tr key={Index}>

            <td style={{whiteSpace:"nowrap"}}>{e.transactionId}</td>
           
            <td>{e.name}</td>
            <td style={{whiteSpace:"nowrap"}}>{e.date} </td >
            <td>{e.amount_to_pay} </td>
            <td>{e.mobile_number} </td>
            <td> {e.email}</td>
            <td>{e.bank_account} </td>
            <td>{e.payment_status}</td>
            <td>{e.ifsc} </td>
            <td>{e.upi} </td>

            {Corpdisplay?<td style={{whiteSpace:"nowrap"}}>
              {CorpEditdisplay?<i class="fa-solid fa-pen-to-square" id="ParoEdit-icon" onClick={()=>SelectPayment(e.transactionId)} ></i>:null}&nbsp;&nbsp;
              {CorpDeletedisplay?<i class="fa-solid fa-trash" id="ParoDelete-icon" onClick={()=>DeletePayment(e.transactionId)}></i>:null}
            </td>:null}
            {/* <td> 
             {e.active==1 ?<button id ='ParoActive-buttonA'onClick={()=>ActiveStatus(e.id,e.active)}>Active</button>:
              <button id ='ParoActive-buttonB'onClick={()=>ActiveStatus(e.id,e.active)}>InActive</button>}
               &nbsp;  <button id ='ParoDelete-buttonC' onClick={()=>ParoDeleteStatus(e.id,e.userName)}>Delete</button>
            </td> */}

          </tr>
            })}
      </tbody>
    </table>
)}
  

 
  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> */}
  </div>
  
</div>
<br></br>
{transdata.length<=5? null:<div id="Paropagi" >

{

!paginatedPosts ? (""):(

<Paginations



totalRecords={NUM_OF_RECORDS}

pageLimit={LIMIT}

pageNeighbours={2}

onPageChanged={onPageChanged}

currentPage={currentPage}

/>

)}

     </div>}


  

    <div className="SaVenturepop-fade" id="PaymentForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content">

      <div className="modal-header text-center">
        <div id='paydiv'>
       <img src={pic} alt="/" id='payimg'/>
        <h4 className="modal-title w-100 font-weight-bold" id='payh4'>Make a Payment </h4>
       </div>

        <button type="button" className="close" onClick={SaCloseform}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <form id='payform' onSubmit={fetchPaymentData} >
      <div className="modal-body mx-3">
        {/* <div className="md-form mb-5">
        
                     <input type="text"className="form-control validate"  id="VentureId"  placeholder='Venture ID'onKeyUp={handlechange} />
                     <span id="IdErr" className='error'></span>
                     <span id="IdErrA" className='error'></span>
                    
           </div> */}


        <div className="md-form mb-5">
          <input type="text" className="form-control validate" placeholder='Name' id='payname' onKeyUp={paymentValidation}/>
                     <span id="PayError" className='error'></span>
                     <span id="nameErrA" className='error'></span>
        </div>

        <div className='md-form mb-5'>
        <input type="date" className="form-control validate" placeholder='Date'  id='paydate'  onInputCapture={paymentValidation}/>
                     <span id="PayError1" className='error'></span>
                     <span id="nameErrA" className='error'></span>
        </div>

        <div className='md-form mb-5'>
        <input type="text" className="form-control validate" placeholder='Amount To Pay'  id='amounttopay'  onKeyUp={paymentValidation}/>
                     <span id="PayError2" className='error'></span>
                     <span id="nameErrA" className='error'></span>
        </div>

        {/* <div className='md-form mb-5'>
        <input type="text" className="form-control validate" placeholder='Payment Status'  id='paymentstatus' onKeyUp={paymentValidation}/>
                     <span id="PayError3" className='error'></span>
                     <span id="nameErrA" className='error'></span>
        </div> */}

        <div className='md-form mb-5'>
        <input type="text" className="form-control validate" placeholder='Mobile Number'  id='paymobilenumber'  onKeyUp={paymentValidation}/>
                     <span id="PayError4" className='error'></span>
                     <span id="PayError4A" className='error'></span>
        </div>

        <div className='md-form mb-5'>
        <input type="text" className="form-control validate" placeholder='Email'  id='payemail'  onKeyUp={paymentValidation}/>
                     <span id="PayError5" className='error'></span>
                     <span id="PayError5A" className='error'></span>
        </div>

        <div className='md-form mb-5'>
        <input type="text" className="form-control validate" placeholder='Bank Account'  id='payaccount'  onKeyUp={paymentValidation}/>
                     <span id="PayError6" className='error'></span>
                     <span id="nameErrA" className='error'></span>
        </div>

        <div className='md-form mb-5'>
        <input type="text" className="form-control validate" placeholder='IFSC'  id='payifsc'  onKeyUp={paymentValidation}/>
                     <span id="PayError7" className='error'></span>
                     <span id="PayError7A" className='error'></span>
        </div>

        <div className='md-form mb-5'>
        <input type="text" className="form-control validate" placeholder='UPI'  id='payupi'  onKeyUp={paymentValidation}/>
                     <span id="PayError8" className='error'></span>
                     <span id="nameErrA" className='error'></span>
        </div>

        

        
        

      </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className="sa-adduser-button" >Submit</button>
      </div>

      </form>

    </div>
  </div>
</div>

    </div>
  )
}

export default ParoPaymentMain